module.exports = __webpack_public_path__ + "static/media/swap-icon.aa4ce73b.svg";